import clsx from "clsx";
import React from "react";
import { Form } from "react-router";

interface Props {
  className?: string | null,
  children: React.ReactNode,
  onSubmit?: React.FormEventHandler<HTMLFormElement>,
}

const ToolForm: React.FC<Props> = (
  {
    className = null,
    children = null,
    onSubmit
  }
) => {
  return (
    <Form
      className={clsx(
        "flex flex-col md:flex-row flex-wrap gap-4 w-full justify-center items-center my-3 px-6 py-10 md:py-16",
        "bg-slate-200 dark:bg-slate-700 rounded-sm text-lg",
        className
      )}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};

export default ToolForm;